export default __webpack_public_path__ + "5f96db7f7a65803965458a0add18c384.png";